import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { formatNumber, round } from 'utils/misc';
import { Header } from 'components/HeroSemantic';

export default class Balance extends Component {
  static propTypes = {
    balance: PropTypes.object,
    property: PropTypes.object,
    children: PropTypes.node.isRequired,
  };

  get outdatedWarning() {
    const { balance } = this.props;
    // NOTE Here we assume that there will only be one contract for the same property for one owner
    // which if there are two contracts existed, only the first found will be returned.
    const contract = balance?.property?.contracts?.find(c => c.ownerId === balance.ownerId);
    // Check if the contract has expired more than 6 months ago
    const isInvalid = contract && moment().diff(contract.ownerTo, 'months') > 6;
    return isInvalid && (
      <Header.Subheader style={{ color: 'var(--owner-warning)' }}>
        <FormattedMessage id="page.financial.requestPayment.outdatedBalance" />
      </Header.Subheader>
    );
  }

  get property() {
    const { balance, property } = this.props;
    const strata = balance ? balance.property?.strata ?? '' : property?.strata ?? '';
    const name = balance ? balance.property?.name ?? '' : property?.name ?? '';
    return (
      <Header as="h3">
        {strata}
        <Header.Subheader>
          {name}
        </Header.Subheader>
      </Header>
    );
  }

  get balance() {
    const { balance } = this.props;
    const amount = balance ? formatNumber(round(balance.amount), { style: 'currency', precision: 0 }) : '';

    return (
      <Header as="h3">
        {amount}
        <Header.Subheader>
          <FormattedMessage
            id={`page.financial.requestPayment.${balance ? 'balance' : 'noBalance'}`}
            values={{ date: balance && moment.utc(balance.validAsAt).local().format('l') }}
          />
        </Header.Subheader>
        { balance && this.outdatedWarning }
      </Header>
    );
  }

  render() {
    const { children } = this.props;

    return (
      <div className="flex flex-col gap-4 border-b border-[var(--owner-border)] py-4 last:border-b-0 sm:flex-row sm:items-center sm:gap-6">
        <div className="min-w-0 flex-1">{this.property}</div>
        <div className="min-w-0 flex-1">{this.balance}</div>
        <div className="w-full sm:w-auto sm:min-w-[180px] sm:max-w-[260px]">{children}</div>
      </div>
    );
  }
}
